import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { getSession, persistSession } from "@/lib/session";
import JoinScreen from "@/components/JoinScreen";
import Festival from "@/components/Festival";

function App() {
  const [session, setSession] = useState(getSession());

  const updateSession = (patch) => {
    setSession((s) => {
      const ns = { ...s, ...patch };
      persistSession(ns);
      return ns;
    });
  };

  return (
    <div className="App">
      {session ? (
        <Festival session={session} onUpdateSession={updateSession} onLeave={() => setSession(null)} />
      ) : (
        <JoinScreen onJoin={setSession} />
      )}
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
